import { useController, type FieldPath, type FieldValues } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface DateFieldProps<TFieldValues extends FieldValues> {
  name: FieldPath<TFieldValues>;
  label: string;
  disabled?: boolean;
}

export function DateField<TFieldValues extends FieldValues>({
  name,
  label,
  disabled,
}: DateFieldProps<TFieldValues>) {
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues>({ name });

  return (
    <div className="space-y-1">
      <Label htmlFor={name}>{label}</Label>
      <Input
        {...field}
        id={name}
        type="date"
        disabled={disabled}
        className={error ? 'border-destructive' : ''}
        value={
          field.value ? (typeof field.value === 'string' ? field.value.split('T')[0] : '') : ''
        }
        onChange={(e) => {
          const val = e.target.value;
          field.onChange(val ? new Date(val).toISOString() : null);
        }}
      />
      {error && <p className="text-xs text-destructive">{error.message}</p>}
    </div>
  );
}
